<template>
  <div class="myApp">
    <a @click='aaa'>打开我的定位页面</a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      params: null
    }
  },
  mounted () {
    const query = this.$route.query
    this.baseUrl = query.baseUrl
    this.params = query['amp;params']
  },
  methods: {
    aaa () {
      window.location.href = `${this.baseUrl}?scanInfo=${this.params}&timeoutWx=${new Date().getTime()}`
    }
  }
}
</script>

<style lang='scss'>
  .myApp{
    padding: 20px;
    background: #dddddd;
    height: 100vh;
  }
</style>
